/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CubeEmptyInfo, CubeInfo, CubeToUpdateInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class CubeClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Cube
   * @summary Получить все кубы
   * @request GET:/Seismic/Cube
   * @secure
   */
  cubeGetAllCubes = (params: RequestParams = {}) =>
    this.http.request<CubeInfo[], any>({
      path: `/Seismic/Cube`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Cube
   * @summary Добавить новый куб
   * @request POST:/Seismic/Cube
   * @secure
   */
  cubeAddCube = (data: CubeInfo, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/Seismic/Cube`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Cube
   * @summary Изменить существующий куб
   * @request PUT:/Seismic/Cube
   * @secure
   */
  cubeUpdateCube = (data: CubeToUpdateInfo, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/Seismic/Cube`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    }) /**
   * No description
   *
   * @tags Cube
   * @summary Удалить существующий куб
   * @request DELETE:/Seismic/Cube
   * @secure
   */
  cubeDeleteCube = (
    query: {
      /**
       * Идентификатор куба
       * @format uuid
       */
      cubeId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/Seismic/Cube`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Cube
   * @summary Получить куб по Id
   * @request GET:/Seismic/Cube/{cubeId}
   * @secure
   */
  cubeGetCubeById = (cubeId: string, params: RequestParams = {}) =>
    this.http.request<CubeInfo, any>({
      path: `/Seismic/Cube/${cubeId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Cube
   * @summary Получить кубы по Id разлома
   * @request GET:/Seismic/Cube/fault/{faultId}
   * @secure
   */
  cubeGetCubesByFaultId = (faultId: string, params: RequestParams = {}) =>
    this.http.request<CubeInfo[], any>({
      path: `/Seismic/Cube/fault/${faultId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Cube
   * @summary Получить кубы по Id месторождения
   * @request GET:/Seismic/Cube/field/{fieldId}
   * @secure
   */
  cubeGetCubesByFieldId = (fieldId: string, params: RequestParams = {}) =>
    this.http.request<CubeInfo[], any>({
      path: `/Seismic/Cube/field/${fieldId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Cube
   * @summary Добавить новый куб без данных
   * @request POST:/Seismic/Cube/AddEmptyCube
   * @secure
   */
  cubeAddEmptyCube = (data: CubeEmptyInfo, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/Seismic/Cube/AddEmptyCube`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
